import { Box, Stack } from "@mui/material";
import { TerminalRounded } from "@mui/icons-material";
import { Custom } from "components";
import { useApp, useTheme } from "contexts";
import { RepoType } from "types";
import { Conversions } from "helpers";
import { EnumTheme } from "utils/enums";

type Props = {
  item: RepoType;
};

export const Repo = (props: Props) => {
  const { theme } = useTheme();
  const { locale, t } = useApp();
  const isDark = theme.id === EnumTheme.Dark;

  const languageColor =
    props.item.language?.toLowerCase() === "javascript"
      ? "#eab308"
      : props.item.language?.toLowerCase() === "typescript"
      ? theme.color.primary.color
      : props.item.language?.toLowerCase() === "go" || props.item.language?.toLowerCase() === "golang"
      ? "#38bdf8"
      : theme.color.secondary.text;

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        p: theme.spacing.md,
        backgroundColor: theme.color.background.accent,
        border: `1px solid ${theme.color.border.color}`,
        borderRadius: theme.border.square,
        boxShadow: `2px 2px 0px 0px ${theme.color.border.color}`,
        transition: "transform 0.15s ease, box-shadow 0.15s ease",
        "&:hover": {
          transform: "translate(-2px, -2px)",
          boxShadow: `3px 3px 0px 0px ${isDark ? "#000000" : "#191b22"}`,
        },
        "&:active": {
          transform: "translate(2px, 2px)",
          boxShadow: "none",
        },
      }}
    >
      <Box>
        <Stack direction="row" spacing={theme.spacing.xs} alignItems="center" sx={{ mb: theme.spacing.sm }}>
          <TerminalRounded
            sx={{
              fontSize: theme.font.md,
              color: theme.color.primary.color,
            }}
          />
          <Box
            component="a"
            target="_blank"
            rel="noopener noreferrer"
            href={props.item.html_url}
            sx={{
              fontWeight: theme.font.bold,
              fontSize: theme.font.sm,
              color: theme.color.font.color,
              textDecoration: "none",
              fontFamily: '"Space Mono", monospace',
              "&:hover": {
                color: theme.color.primary.color,
                textDecoration: "underline",
              },
            }}
          >
            {props.item.name}
          </Box>
        </Stack>

        {/* <Custom.Typography
          variant="body2"
          sx={{
            color: theme.color.font.accent,
            lineHeight: 1.55,
            mb: theme.spacing.md,
            fontSize: theme.font.xs,
          }}
        >
          {props.item.description || (t.scale["1"] ? t.scale["1"].label : "Open-source module")}
        </Custom.Typography> */}
      </Box>

      <Box
        sx={{
          pt: theme.spacing.sm,
          borderTop: `1px solid ${theme.color.border.color}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontFamily: '"Space Mono", monospace',
          fontSize: theme.font.xxxs,
          color: theme.color.font.accent,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: theme.spacing.xs }}>
          <Box
            component="span"
            sx={{
              width: 8,
              height: 8,
              backgroundColor: languageColor,
              display: "inline-block",
            }}
          />
          <Box component="span" sx={{ fontWeight: theme.font.semiBold }}>
            {props.item.language || "Module"}
          </Box>
        </Box>

        <Box component="span">
          {Conversions.formattedDate(new Date(props.item.updated_at), locale.toLowerCase())}
        </Box>
      </Box>
    </Box>
  );
};